export default {
  APP: {
    NAME: 'Brokers',
    COMPANY: 'Freightforge'
  },
  ACTIONS: {
    ACCEPT: 'Accepter',
    ADD: 'Créer',
    APPLY: 'Appliquer',
    RETRY: 'Réessayer',
    CLEAR: 'Effacer',
    CANCEL: 'Annuler',
    INSTALL: 'Installer',
    CLOSE: 'Fermer',
    LOG_OUT: 'Se déconnecter',
    IS_LOADING: 'Chargement en cours ...'
  },
  EQUIPMENT_TYPES: {
    V: 'Dry Van',
    F: 'Flatbed',
    R: 'Reefer',
    LT: 'Liquidity Totes',
    LB: 'Lowboy',
    HS: 'Hotshot',
    CV: 'Curtain van',
    V_V: 'Vented Van',
    F_S: 'Flat + Sides',
    TNK: 'Tank',
    CONT: 'Container',
    PNEU: 'Pneumatic',
    F_T: 'Flat + Tarp',
    BT: 'Box truck',
    C: 'Conestoga',
    PO: 'Power only',
    LA: 'Landall',
    DT: 'Dump trailer',
    CRG: 'Cargo van',
    MX: 'Maxi flat',
    AC: 'Auto Carrier',
    DD: 'Double drop',
    HB: 'Hopper bottom',
    VINT: 'Van - intermodal',
    FINT: 'Flat - intermodal',
    RINT: 'Reefer - intermodal',
    SD: 'Step deck',
    RGN: 'Removable gooseneck',
    SPEC: 'Special commodity'
  },
  PACKAGING_TYPES: {
    BOX: 'Box',
    PALLET: 'Pallet',
    CONTAINER: 'Container',
    BULK: 'Bulk',
    OVERSIZED: 'Oversized',
    LINEAR: 'Linear Feet',
    SLIPSHEET: 'Slip Sheet'
  },
  DATE: {
    YESTERDAY: 'Hier',
    TODAY: 'Aujourd\'hui',
    TOMORROW: 'Demain'
  },
  OFFLINE: {
    IS_OFFLINE: {
      SHORT: 'Hors-ligne'
    }
  },
  QUOTES_LIST: {
    TITLE: '@:APP.NAME',
    FILTERS: {
      TITLE: 'Filtrer par'
    },
    SORTS: {
      TITLE: 'Trier par'
    },
    ERRORS: {
      GET: {
        LABEL: 'Oups !',
        DESCRIPTION: 'Erreur lors de la récupération des chargements, merci de réessayer ultérieurement.'
      },
      NOTHING_TO_SEE: {
        LABEL: 'Aucun résultat',
        DESCRIPTION: ''
      }
    }
  },
  QUOTES_DETAIL: {
    TITLE: 'Détails',
    ERRORS: {
      NOTHING_TO_SEE: {
        LABEL: 'Aucun résultat'
      }
    },
    EXPECTED_AMOUNT: {
      TITLE: 'Montant'
    },
    EQUIPMENT_TYPE: {
      TITLE: 'Equipement',
      V: '@:EQUIPMENT_TYPES.V',
      F: '@:EQUIPMENT_TYPES.F',
      R: '@:EQUIPMENT_TYPES.R',
      LT: '@:EQUIPMENT_TYPES.LT',
      LB: '@:EQUIPMENT_TYPES.LB',
      HS: '@:EQUIPMENT_TYPES.HS',
      CV: '@:EQUIPMENT_TYPES.CV',
      V_V: '@:EQUIPMENT_TYPES.V_V',
      F_S: '@:EQUIPMENT_TYPES.F_S',
      TNK: '@:EQUIPMENT_TYPES.TNK',
      CONT: '@:EQUIPMENT_TYPES.CONT',
      PNEU: '@:EQUIPMENT_TYPES.PNEU',
      F_T: '@:EQUIPMENT_TYPES.F_T',
      BT: '@:EQUIPMENT_TYPES.BT',
      C: '@:EQUIPMENT_TYPES.C',
      PO: '@:EQUIPMENT_TYPES.PO',
      LA: '@:EQUIPMENT_TYPES.LA',
      DT: '@:EQUIPMENT_TYPES.DT',
      CRG: '@:EQUIPMENT_TYPES.CRG',
      MX: '@:EQUIPMENT_TYPES.MX',
      AC: '@:EQUIPMENT_TYPES.AC',
      DD: '@:EQUIPMENT_TYPES.DD',
      HB: '@:EQUIPMENT_TYPES.HB',
      VINT: '@:EQUIPMENT_TYPES.VINT',
      FINT: '@:EQUIPMENT_TYPES.FINT',
      RINT: '@:EQUIPMENT_TYPES.RINT',
      SD: '@:EQUIPMENT_TYPES.SD',
      RGN: '@:EQUIPMENT_TYPES.RGN',
      SPEC: '@:EQUIPMENT_TYPES.SPEC'
    },
    PACKAGING_TYPE: {
      TITLE: 'Packaging',
      BOX: '@:PACKAGING_TYPES.BOX',
      PALLET: '@:PACKAGING_TYPES.PALLET',
      CONTAINER: '@:PACKAGING_TYPES.CONTAINER',
      BULK: '@:PACKAGING_TYPES.BULK',
      OVERSIZED: '@:PACKAGING_TYPES.OVERSIZED',
      LINEAR: '@:PACKAGING_TYPES.LINEAR',
      SLIPSHEET: '@:PACKAGING_TYPES.SLIPSHEET'
    },
    WEIGHT: {
      TITLE: 'Poids'
    },
    PICKUP: {
      TITLE: 'Retrait'
    },
    DELIVERY: {
      TITLE: 'Livraison'
    },
    RATE_RESPONSE: {
      TITLE: 'Taux de réponses'
    },
    PROMPT: 'Sûr ?'
  },
  QUOTES_LIST_FILTERS_FIELDS: {
    TITLE: 'Réponse',
    RESPONDED: {
      TITLE: 'Avec réponse'
    },
    MANAGEABLE: {
      TITLE: 'Gérable'
    }
  },
  QUOTES_LIST_SORTS_FIELDS: {
    PICKUP: {
      EARLIEST_DATE: {
        TITLE: 'Date de retrait la plus récente'
      }
    },
    DELIVERY: {
      EARLIEST_DATE: {
        TITLE: 'Date de livraison la plus récente'
      }
    },
    DEADLINE: {
      TITLE: 'Date de fin la plus récente'
    }
  },
  QUOTES_LIST_RESUME: {
    EQUIPMENT_TYPE: {
      V: '@:EQUIPMENT_TYPES.V',
      F: '@:EQUIPMENT_TYPES.F',
      R: '@:EQUIPMENT_TYPES.R',
      LT: '@:EQUIPMENT_TYPES.LT',
      LB: '@:EQUIPMENT_TYPES.LB',
      HS: '@:EQUIPMENT_TYPES.HS',
      CV: '@:EQUIPMENT_TYPES.CV',
      V_V: '@:EQUIPMENT_TYPES.V_V',
      F_S: '@:EQUIPMENT_TYPES.F_S',
      TNK: '@:EQUIPMENT_TYPES.TNK',
      CONT: '@:EQUIPMENT_TYPES.CONT',
      PNEU: '@:EQUIPMENT_TYPES.PNEU',
      F_T: '@:EQUIPMENT_TYPES.F_T',
      BT: '@:EQUIPMENT_TYPES.BT',
      C: '@:EQUIPMENT_TYPES.C',
      PO: '@:EQUIPMENT_TYPES.PO',
      LA: '@:EQUIPMENT_TYPES.LA',
      DT: '@:EQUIPMENT_TYPES.DT',
      CRG: '@:EQUIPMENT_TYPES.CRG',
      MX: '@:EQUIPMENT_TYPES.MX',
      AC: '@:EQUIPMENT_TYPES.AC',
      DD: '@:EQUIPMENT_TYPES.DD',
      HB: '@:EQUIPMENT_TYPES.HB',
      VINT: '@:EQUIPMENT_TYPES.VINT',
      FINT: '@:EQUIPMENT_TYPES.FINT',
      RINT: '@:EQUIPMENT_TYPES.RINT',
      SD: '@:EQUIPMENT_TYPES.SD',
      RGN: '@:EQUIPMENT_TYPES.RGN',
      SPEC: '@:EQUIPMENT_TYPES.SPEC'
    },
    PACKAGING_TYPE: {
      BOX: '@:PACKAGING_TYPES.BOX',
      PALLET: '@:PACKAGING_TYPES.PALLET',
      CONTAINER: '@:PACKAGING_TYPES.CONTAINER',
      BULK: '@:PACKAGING_TYPES.BULK',
      OVERSIZED: '@:PACKAGING_TYPES.OVERSIZED',
      LINEAR: '@:PACKAGING_TYPES.LINEAR',
      SLIPSHEET: '@:PACKAGING_TYPES.SLIPSHEET'
    }
  },
  QUOTES_DETAIL_LOCATION_AND_DATE: {
    IS_NOT_FLEXIBLE: 'Non flexible'
  },
  TYPES_CHECKBOX: {
    V: '@:EQUIPMENT_TYPES.V',
    F: '@:EQUIPMENT_TYPES.F',
    R: '@:EQUIPMENT_TYPES.R',
    LT: '@:EQUIPMENT_TYPES.LT',
    LB: '@:EQUIPMENT_TYPES.LB',
    HS: '@:EQUIPMENT_TYPES.HS',
    CV: '@:EQUIPMENT_TYPES.CV',
    V_V: '@:EQUIPMENT_TYPES.V_V',
    F_S: '@:EQUIPMENT_TYPES.F_S',
    TNK: '@:EQUIPMENT_TYPES.TNK',
    CONT: '@:EQUIPMENT_TYPES.CONT',
    PNEU: '@:EQUIPMENT_TYPES.PNEU',
    F_T: '@:EQUIPMENT_TYPES.F_T',
    BT: '@:EQUIPMENT_TYPES.BT',
    C: '@:EQUIPMENT_TYPES.C',
    PO: '@:EQUIPMENT_TYPES.PO',
    LA: '@:EQUIPMENT_TYPES.LA',
    DT: '@:EQUIPMENT_TYPES.DT',
    CRG: '@:EQUIPMENT_TYPES.CRG',
    MX: '@:EQUIPMENT_TYPES.MX',
    AC: '@:EQUIPMENT_TYPES.AC',
    DD: '@:EQUIPMENT_TYPES.DD',
    HB: '@:EQUIPMENT_TYPES.HB',
    VINT: '@:EQUIPMENT_TYPES.VINT',
    FINT: '@:EQUIPMENT_TYPES.FINT',
    RINT: '@:EQUIPMENT_TYPES.RINT',
    SD: '@:EQUIPMENT_TYPES.SD',
    RGN: '@:EQUIPMENT_TYPES.RGN',
    SPEC: '@:EQUIPMENT_TYPES.SPEC',
    BOX: '@:PACKAGING_TYPES.BOX',
    PALLET: '@:PACKAGING_TYPES.PALLET',
    CONTAINER: '@:PACKAGING_TYPES.CONTAINER',
    BULK: '@:PACKAGING_TYPES.BULK',
    OVERSIZED: '@:PACKAGING_TYPES.OVERSIZED',
    LINEAR: '@:PACKAGING_TYPES.LINEAR',
    SLIPSHEET: '@:PACKAGING_TYPES.SLIPSHEET'
  },
  EQUIPMENT_TYPES_CHECKBOX: {
    TITLE: 'Equipements'
  },
  PACKAGING_TYPES_CHECKBOX: {
    TITLE: 'Packaging'
  },
  PICKUP_REGIONS_SELECT: {
    TITLE: 'Retrait'
  },
  DELIVERY_REGIONS_SELECT: {
    TITLE: 'Livraison'
  },
  PWA_INSTALLER: {
    TITLE: '@:ACTIONS.INSTALL @:APP.NAME de @:APP.COMPANY sur votre mobile'
  },
  CONNECTED_USER: {
    ERRORS: {
      GET: 'Erreur lors de la récupération de l\'utilisateur connecté',
      LOG_OUT: 'Erreur lors de la déconnexion'
    }
  },
  STATE_ALERT: {
    OPEN: 'Ouvert',
    PENDING: 'En cours',
    ALLOCATED: 'Alloué',
    EXECUTED: 'Exécuté',
    CANCELED: 'Annulé'
  }
}
